import { action, thunk } from 'easy-peasy';

export default {
	loading: false,
	setLoading: action((state, payload) => {
		state.loading = payload;
	}),
	items: [],
	viewRows: [],
	setViewRows: action((state, payload) => {
		state.viewRows = payload;
	}),
	orderBy: 'id',
	orderDirection: 'desc',
	setOrder: action((state, payload) => {
		if (state.orderBy === payload) {
			state.orderDirection = state.orderDirection === 'asc' ? 'desc' : 'asc';
		} else {
			state.orderDirection = 'asc';
		}
		state.orderBy = payload;
	}),
	selectAll: action((state, payload) => {
		state.items = state.items.map(item => ({
			...item,
			isSelected: true
		}));
	}),
	deselectAll: action((state, payload) => {
		state.items = state.items.map(item => ({
			...item,
			isSelected: false
		}));
	}),
	toggleSelection: action((state, payload) => {
		state.items = state.items.map(item => ({
			...item,
			isSelected: item.id === payload ? !item.isSelected : item.isSelected
		}));
	}),
	save: action((state, payload) => {
		state.items = payload.data.items.map(item => ({
			...item,
			isSelected: false
		}));
	}),
	retrieve: thunk((actions, payload, { getStoreState, getState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoading(true);
		return services.kit
			.retrieve()
			.then(data => {
				actions.save({ data });
			})
			.catch(e => {
				getStoreActions().error('kit.search');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	}),
	/*
	load: thunk((actions, payload, { getStoreState, getState, injections, getStoreActions }) => {
		const { services } = injections;
		const filters = getStoreState().kit.filters.list;
		const params = { filters };
		actions.setLoading(true);
		return services.kit
			.search(params)
			.then(data => {
				actions.save({ data });
			})
			.catch(e => {
				getStoreActions().error('kit.search');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	}),
	*/
	deleteKit: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoading(true);
		return services.kit
			.deleteKit(payload)
			.then(data => {
				actions.retrieve();
			})
			.catch(e => {
				getStoreActions().error('kit.delete');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	})
};
